"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseButlerConfig = exports.getButlerConfig = exports.PublicEventButler = void 0;
const parametric_graph_1 = require("@evidenceb/parametric-graph");
const interfaces_1 = require("./interfaces");
const ai_handler_1 = require("@evidenceb/ai-handler");
const event_butler_1 = require("./event-butler");
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const utils_1 = require("./utils");
/**
 * default congif for AI Agent for now
 */
let agentConfig = {
    studentActivityMonitorAgent: {
        config: [
            {
                criteria: "comparaison",
                id: "comparaison",
                mesure: "mmp",
                param: { nb_step: 4, threshold: 0.5, stepToCompute: 4, tolerance: 0.1 },
            },
            // {
            //     'criteria': 'comparaison',
            //     'id': 'comparaisonInstantanee',
            //     'mesure': 'mmp',
            //     'param': { 'nb_step': 1, 'threshold': 0.75, 'stepToCompute': 1, 'tolerance': 0.1 }
            // },
            {
                criteria: "flag",
                id: "flag",
                mesure: "score",
                param: { nb_step: 4, threshold: 0.4, stepToCompute: 4 },
            },
        ],
    },
};
/**
 * Classe qui permet de n'exposer au front que des méthodes utiles
 */
class PublicEventButler {
    constructor(args) {
        const butlerConfig = (0, exports.getButlerConfig)(args);
        this.eventButler = new event_butler_1.EventButler(args.moduleId, butlerConfig.listAiEngineId, butlerConfig.aiEnginesConfigs, args.history, args.eventStream, args.app, args.userId, args.sessionId, args.workmode, butlerConfig.listAiAgentId, agentConfig, { lockedResources: args.lockedResources });
    }
    getAiEngine(engineId) {
        return this.eventButler.getAiEngine(engineId);
    }
    set_revisionAlg_SimulationDate(date) {
        this.eventButler.set_revisionAlg_SimulationDate(date);
    }
    getNextHierarchyIds() {
        return this.eventButler.sample_from_history([]);
    }
    updateHistoryAndGetNextHierarchyIds(historyItem) {
        return this.eventButler.sample_from_history([historyItem]);
    }
    isAdaptiveTestInProgress() {
        return this.eventButler.aiEngineToSampleActivity === interfaces_1.AIEnginesIDs.adaptiveTest || this.eventButler.aiEngineToSampleActivity === interfaces_1.AIEnginesIDs.cnedAdaptiveTest;
    }
    getTestsStatus() {
        return {
            isInitialTest: this.eventButler.isSampleFromInitialTest,
            isAdaptiveTest: this.isAdaptiveTestInProgress(),
        };
    }
    isModuleFinished() {
        return this.eventButler.isCurriculumFinished();
    }
    // SET ENGINE FOR ACTIVITY SAMPLING
    startRevision() {
        this.eventButler.set_aiEngineToSampleActivity(interfaces_1.AIEnginesIDs.revisionAlg);
    }
    stopRevision() {
        this.eventButler.set_aiEngineToSampleActivity(interfaces_1.AIEnginesIDs.zpdes);
    }
    isRevisionAvailable() {
        return this.eventButler.isRevisionAvailable();
    }
    registerSubscriber(params) {
        var _a;
        (_a = this.eventButler.stream) === null || _a === void 0 ? void 0 : _a.registerSubscriber(params);
    }
    // DIAGNOSES
    getZPDESBasicDiagnosis() {
        const diagnosis = this.eventButler.get_aiEngine_student_diagnosis(interfaces_1.AIEnginesIDs.zpdes);
        return {
            progression: Math.floor(diagnosis.graphe_coverage_rate * 100),
            averageScore: Math.floor(diagnosis.mean_student_score * 100),
        };
    }
    getZPDESFullDiagnosis() {
        return this.eventButler.get_full_diagnostic();
    }
    getButlerZPDESFullDiagnosis() {
        return this.eventButler.getZpdesFullDiag();
    }
    getAdaptiveTestDiagnosis() {
        // The 2 tests are mutually exclusive
        const testEngine = this.eventButler.aiEngines[interfaces_1.AIEnginesIDs.cnedAdaptiveTest] ? interfaces_1.AIEnginesIDs.cnedAdaptiveTest : interfaces_1.AIEnginesIDs.adaptiveTest;
        return this.eventButler.get_aiEngine_student_diagnosis(testEngine);
    }
}
exports.PublicEventButler = PublicEventButler;
// to do : Add field for multiGraphManagement, field value must be common-ai-config
const getButlerConfig = ({ aiTypes, forceAiTypes, moduleId, aiConfig, 
//baseAIConfig
data, adaptiveTestDiagnosis, }) => {
    // TO DO : use baseAiConfig bc makemultigraph / problem with AIConfig which is created and specialized for ZPDES but not for other AI alg
    let { listAiEngineId, listAiAgentId } = (0, utils_1.setUpListAiEngineForModule)(aiConfig.moduleConfig, moduleId, aiTypes, forceAiTypes);
    let aiConfigPerAi;
    if ((forceAiTypes && aiTypes !== undefined) || (!aiConfig.moduleConfig[moduleId].moduleAiEnginesSetUp && aiTypes !== undefined)) {
        aiConfigPerAi = [...listAiEngineId].reduce((result, aiEngineId) => (Object.assign(Object.assign({}, result), { [aiEngineId]: Object.assign(Object.assign({}, (0, lodash_clonedeep_1.default)(aiConfig)), { baseConfig: Object.assign(Object.assign({}, (0, lodash_clonedeep_1.default)(aiConfig.baseConfig)), { algo_name: aiEngineId }), id: aiEngineId }) })), {});
    }
    else {
        let moduleConfigPerAI = (0, ai_handler_1.makeMultiGraphConfig)(aiConfig.moduleConfig, moduleId);
        aiConfigPerAi = multiGraphToAiConfigDict(moduleConfigPerAI, aiConfig);
    }
    const config = (0, exports.getBaseButlerConfig)({
        //aiTypes,
        listAiEngineId,
        moduleId,
        //aiConfig,
        aiConfigPerAi,
        data,
    });
    if (interfaces_1.AIEnginesIDs.adaptiveTest in config && config[interfaces_1.AIEnginesIDs.adaptiveTest] && adaptiveTestDiagnosis) {
        config[interfaces_1.AIEnginesIDs.adaptiveTest].adaptiveTestDiagnosis = adaptiveTestDiagnosis.predictedCompetences;
    }
    let finalConfig = {
        listAiEngineId: listAiEngineId,
        listAiAgentId: listAiAgentId,
        aiEnginesConfigs: config,
    };
    return finalConfig;
};
exports.getButlerConfig = getButlerConfig;
const getBaseButlerConfig = ({ listAiEngineId, moduleId, 
//aiConfig,
aiConfigPerAi, data, }) => Array.from(listAiEngineId).reduce((config, aiEngineId) => {
    var _a, _b, _c;
    // let aiConfigPerType = aiConfig[aiType]
    const aiEngineIdConfig = aiConfigPerAi[aiEngineId];
    // refacto for multiGraph : replace above line by
    // var aiEngineIdConfig = aiConfig[aiEngineId];
    // aiEngineIdConfig.moduleConfig = moduleConfigPerAI.aiEngineId
    if (!aiEngineIdConfig)
        throw new Error(`Missing ai config for ${aiEngineId}`);
    const { params, parametricGraph } = initParams(moduleId, aiEngineIdConfig, data);
    if (aiEngineId === interfaces_1.AIEnginesIDs.adaptiveTest) {
        const moduleAiEnginesSetUp = (_c = (_b = (_a = aiConfigPerAi[aiEngineId]) === null || _a === void 0 ? void 0 : _a.moduleConfig) === null || _b === void 0 ? void 0 : _b[moduleId]) === null || _c === void 0 ? void 0 : _c.moduleAiEnginesSetUp;
        if (moduleAiEnginesSetUp) {
            return Object.assign(Object.assign({}, config), { [aiEngineId]: {
                    config: { params, parametricGraph },
                    bo: moduleAiEnginesSetUp.bo_value,
                    min: moduleAiEnginesSetUp.AT_min,
                    max: moduleAiEnginesSetUp.AT_max,
                } });
        }
    }
    return Object.assign(Object.assign({}, config), { [aiEngineId]: {
            config: { params, parametricGraph },
        } });
}, {});
exports.getBaseButlerConfig = getBaseButlerConfig;
const initParams = (moduleId, aiEngineIdConfig, data) => {
    const params = (0, ai_handler_1.getParamsFromConfigData)(aiEngineIdConfig, data, moduleId);
    const parametricGraph = (0, parametric_graph_1.makeGraphFromData)(params, moduleId);
    return { params, parametricGraph };
};
const multiGraphToAiConfigDict = (moduleConfigPerAI, aiConfig) => {
    let aiConfigDict = {};
    for (let aiEngineId of Object.keys(moduleConfigPerAI)) {
        aiConfigDict[aiEngineId] = {
            id: aiEngineId,
            baseConfig: aiConfig.baseConfig,
            moduleConfig: moduleConfigPerAI[aiEngineId],
            initialTest: aiConfig.initialTest,
        };
    }
    return aiConfigDict;
};
